<script setup lang="ts">
import type { ISkuSelectorOption } from '../models';
import { MMText } from '@mm-frontend/mm-web-ui-kit';

const props = defineProps<{
  option: ISkuSelectorOption;
  isActive?: boolean;
  isUnavailable?: boolean;
}>();

const styleObj = computed(() => {
  const obj = {} as any;

  props.option.photo
    ? (obj.backgroundImage = `url(${props.option.photo})`)
    : (obj.backgroundColor = props.option.value);

  return obj;
});
</script>

<template>
  <div
    class="sku-option-image"
    :class="{
      'sku-option-image_active': isActive,
      'sku-option-image_unavailable': isUnavailable,
    }"
  >
    <div :style="styleObj" />
  </div>
</template>

<style scoped lang="stylus">
.sku-option-image
  box-sizing border-box
  width 63px
  height 84px
  border-radius 10px
  cursor pointer
  display flex
  align-items center
  justify-content center
  background-color #ffffff
  overflow hidden
  transition-duration .1s
  border solid 1px var(--border-regular)

  & > div
    width 100%
    height 100%
    background-color #EFEFEF
    background-position center
    background-size 100%
    background-repeat no-repeat
    position relative
    overflow hidden
    display flex
    align-items center
    justify-content center
    border-radius 8px

  &_active
    outline solid 2px var(--border-focused)
    outline-offset -2px
    padding 2px
    & > div
      border-radius 7px

  &_unavailable
    & > div
      opacity .7
      &::after
        content ''
        background-color var(--border-disabled)
        border solid 1px #FFFFFF
        position absolute
        transform rotateZ(-35deg)
        height 168px
        width 1px
</style>
